<template>
	<div class="dayi">
		  <div class="tvwrap w12">
				<div class="tvwrapleft comborder">
					<h2 class="comtitle">
						<strong>{{lmname}}</strong>
						<span>当前位置：<a href="/">北京冠领律师事务所拆迁官网</a> > <router-link :to="{path:pathInfo.path}">{{pathInfo.name}}</router-link> </span> 
					</h2>
					<ul>
	
						<li v-for="item in anliData" :key="item.id">
							<router-link :to="{path:'list/v/'+item.id+'.html'}">{{item.title}}</router-link><span>{{item.create_time}}</span>	
						</li>

					</ul>
	
					<div class="page">
								   <!-- hide-on-single-page -->
					 <el-pagination
					   background
					   hide-on-single-page
					   :current-page.sync='currentpage'
					   @current-change="getPage"
					   layout="prev, pager, next"
					   prev-text="上一页"
					   next-text="下一页"
					   :page-size="pagesize"
					   :pager-count = pagerCount
					   :total="total">
					 </el-pagination>
					</div>
	
	
				</div>
				<Aside :lmname="lmname"/>
	
			</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import Aside from "../components/Aside"
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	export default{
		name:'Dayi',
		components:{
			Aside
		},
		data(){
			return {
				pagesize:20,
				breadcrumbList:[],
				anliData:[],
				currentpage:1,
				pagerCount:7,
				total:0,
				lmid:0,
				lmname:'',
				url:''
			}
		},
		methods:{
			getData(){
				let that = this
				request({
					url: '/dayi/liebiao?xid=44&zmid=50&page='+that.currentpage+'&page_size=15',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.anliData = []
							let beforeData = jsondata['data']
							// console.log(beforeData)
							beforeData.forEach(function(value,index,arr){

								value['create_time'] = value['create_time'].split(' ')[0]
	
								
							})
							that.anliData = beforeData
							that.total = beforeData['total']
							// that.currentpage = parseInt(beforeData['current_page'])
								
			
						}
					}]
				})
			},
			getPage(val){
				let that = this
				that.currentpage = val
				request({
					url: '/dayi/liebiao?xid=44&zmid=50&page='+val+'&page_size=15',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.anliData = []
							let beforeData = jsondata['data']
							beforeData.forEach(function(value,index,arr){
				
								value['create_time'] = value['create_time'].split(' ')[0]
	
								
							})
							that.anliData = beforeData

							// that.currentpage = parseInt(beforeData['current_page'])
								
							
						}
					}]
				})
			},
			// getlmname(){
			// 	let that = this
			// 	request({
			// 		url: '/Category/read?id='+that.lmid,
			// 		responseType: 'json',
			// 		transformResponse:[function(data){
			// 			let jsondata = JSON.parse(data)
			// 			// console.log(jsondata);
			// 			if(jsondata['code'] == 200){
			// 				that.lmname = []
			// 				let beforeData = jsondata['data']
			// 				that.lmname = beforeData['name']
			// 				// that.pid = beforeData['pid']
			// 			}
			// 		}]
			// 	})
			// },
			initData(){
				let that = this
				that.pathInfo = this.$route.meta.parent[0]
				
				that.lmname = this.$route.meta.parent[0].name
				
				let from = this.$route.params.from
				if(from == 'index'){
					that.lmid = 44
				}else if(from == 'wenda'){
					that.lmid = 45
				}
				that.getData()
			}
		},
		created() {
			this.initData()
		
		},

		watch:{
		  $route(to, from){
			
			this.initData()
		  }
		}
	}
</script>

<style lang="scss" scoped>
.page{
	padding-bottom: 30px;
}
.tvwrap{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .tvwrapleft{
        width: 915px;
        background: #fff;
            h2.comtitle{
                justify-content: flex-start;
                strong{
                    width: 220px;
                    margin-left: 5px;
                }
                strong::after{
                    left: 19%;
                    
                }
                span{
                    font-size: 14px;
                    margin-left: 15px;
                }
				a{
					margin: 0 5px;
				}
            }
            ul{
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 25px;
                padding: 0 26px;
                margin-top: 20px;
                li{
                    width: 100%;
                    font-size: 18px;
                    border-bottom: 1px solid #ecebeb;
                    height: 55px;
                    line-height: 55px;
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    a{
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: block;
                        width: 80%;
                        margin-left: 20px;
                    }
                }
                li::after{
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 22px;
                    width: 9px;
                    height: 9px;
                    background: #e73825;
                    margin-right: 10px;
                }  
            }
    }




}
</style>